// tslint:disable-next-line:no-var-requires
import { v4 as uuidv4 } from "uuid";

import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  BooleanField,
  BooleanInput,
  NumberInput,
  NumberField,
  useListContext,
  FilterButton,
  TopToolbar,
  sanitizeListRestProps,

  Button
} from "react-admin";
import { cloneElement } from "react";

import { JsonField, JsonInput } from "react-admin-json-view";
import { useRecordContext } from 'react-admin';


const MyUrlField = ({ source }) => {
  const record = useRecordContext();
  const value = record && record[source];


  if (value == null) {
    return null;
  }
  else {
    let lat = null;
    let lng = null;
    if (value.coordinates) {
      if (value.coordinates.length > 0) {
        lat = value.coordinates[1]
        lng = value.coordinates[0]
      }
    }

    return (
      <a target="__blank" href={`http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify(record.geometry))}`}>
        {`Voir le quartier`}
      </a>
    );
  }
}
MyUrlField.defaultProps = {
  addLabel: true,
};
const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[100, 300, 500]} {...props} />
);

const PaFilter = (props) => (
  <Filter {...props}>
    <TextInput label="id" source="id" alwaysOn />
    <TextInput label="Type" source="type" alwaysOn />
    <TextInput label="Region" source="region" alwaysOn />
    <TextInput label="Province" source="province" alwaysOn />
    <TextInput label="Commune" source="commune" alwaysOn />
    <TextInput label="Quartier" source="quartier" alwaysOn />
    <NumberInput label="Prix force appartement" source="prix_appartement_force" alwaysOn />
    <NumberInput label="Prix force villa" source="prix_villa_force" alwaysOn />
    <BooleanInput label="Display Appartement" source="display_appartement" />
    <BooleanInput label="Display Villa" source="display_villa" />
  </Filter>
);
const Aside = () => {
  const { data, isLoading, selectedIds } = useListContext();
  if (isLoading) return null;
  console.log({
    "type": "FeatureCollection",
    "features": Object.keys(data).map(key => {
      return ({
        ...data[key], type: "Feature", properties: {
          _id: data[key].id,
          province: data[key].province,
          commune: data[key].commune,
          quartier: data[key].quartier,
        }
      })
    }).filter(item => {
      return (selectedIds.includes(item.id))
    })
  })
  console.log(selectedIds)
  return (
    <TopToolbar>

      <a target="__blank" href={`http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify({
        "type": "FeatureCollection",
        "features": Object.keys(data).map(key => {

          return ({
            ...data[key], type: "Feature", properties: {
              _id: data[key].id,
              province: data[key].province,
              commune: data[key].commune,
              quartier: data[key].quartier,
            }
          })

        }).filter(item => {
          return (selectedIds.includes(item.id))
        })
      }))}`}>
        {`Voir les quartiers sélectionnés`}
      </a>

    </TopToolbar>
  );
};
const PostBulkActionButtons = () => (
  <>
    <div></div>
  </>
);

const Ajouter = () => {
  return (
    <Button
      onClick={() => {
        window.open(`/add/pas/${uuidv4()}`);
      }}

      label="Ajouter un nouveau"
    >

    </Button >
  )
}
const ListActions = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const {
    currentSort,
    resource,
    displayedFilters,
    filterValues,
    // hasCreate,
    basePath,
    // selectedIds,
    showFilter,
    total,
  } = useListContext();

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      <Ajouter />
    </TopToolbar>
  );
};
export const PaList = (props) => (
  <List {...props}
    actions={<ListActions />}
    filters={<PaFilter />} pagination={<PostPagination />}
    bulkActionButtons={<PostBulkActionButtons />}
    aside={<Aside />}>
    <Datagrid bulkActionButtons={<PostBulkActionButtons />}>
      <TextField source="id" />
      <TextField source="type" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <TextField source="quartier" />
      <NumberField source="prix_appartement_force" alwaysOn />
      <NumberField source="prix_villa_force" alwaysOn />
      <BooleanField source="display_appartement" />
      <BooleanField source="display_villa" />
      <BooleanField source="replaced" label="remplacé" />
      <MyUrlField source="geometry" label="Découpage" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

const WithProps = ({ children, ...props }) => children(props);


export const PaShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <MyUrlField source="geometry" label="Découpage" />
      <WithProps {...props}>
        {({ record, ...props }) => {
          console.log(record)
          return (
            <div className={"remplacer_container"}>
              <a className={"remplacer_button"} href={`/replace/pas/${record.id}`} onClick={() => {
                window.open(`http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify({
                  "type": "FeatureCollection",
                  "features": [{
                    "type": "Feature",
                    "geometry": record.geometry
                  }]
                }))}`)
              }}>
                Remplacer
              </a>
            </div >
          )
        }}
      </WithProps >
      <TextField source="type" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <TextField source="quartier" />
      <JsonField source="properties" />
      <BooleanField source="display_appartement" />
      <BooleanField source="display_villa" />
    </SimpleShowLayout >
  </Show >
);

export const PaEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <BooleanInput source="display_appartement" />
      <BooleanInput source="display_villa" />
      <TextInput source="id" />
      <TextInput source="type" />
      <TextInput source="region" />
      <TextInput source="province" />
      <TextInput source="commune" />
      <TextInput source="quartier" />
      <TextInput source="quartier_id" />
      <NumberInput label="Prix force appartement" source="prix_appartement_force" />
      <NumberInput label="Prix force villa" source="prix_villa_force" />
      <JsonInput source="properties" />

    </SimpleForm>
  </Edit>
);
